import React, { PureComponent, Fragment } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button, { ButtonVariations } from '../../../../../../SolvPatternLibrary/Button';
import { colors } from '../../../../../../../constants/colors';
import { fontSize } from '../../../../../../../constants/text';
import { TileRules } from '../../../util/tileEnums';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import {
  REMINDERS_ACTION,
  REMINDERS_SET_NOT_RELEVANT,
} from '../../../../../../Account/Profile/Reminders/util/tracking';

const Root = styled.div.withConfig({ componentId: 'sc-1udmb20-0' })`
  margin: 14px 0;
  display: flex;

  & > * {
    margin-right: 8px;
  }

  & *:last-child {
    margin-right: 0;
  }
`;

const ReminderButton = styled(Button).withConfig({ componentId: 'sc-1udmb20-1' })`
  width: 73px;
  padding: 0;
`;

const NotRelevant = styled.div.withConfig({ componentId: 'sc-1udmb20-2' })`
  color: ${colors.blueJayWay};
  font-size: ${fontSize.small};
  align-self: center;
  cursor: pointer;
`;

type Props = {
  tile?: object;
  userProfile?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  handler?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  setMale?: func;
};

type State = any;

export default class DefaultButtons extends PureComponent<Props, State> {
  state = { clickedMale: false };

  handleRelevantClick = () => {
    const {
      setMale,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'object | ... Remove this comment to see the full error message
      tile: { title, id },
    } = this.props;
    this.setState({ clickedMale: true });
    analyticsTrackEvent(REMINDERS_ACTION, {
      action: REMINDERS_SET_NOT_RELEVANT,
      title,
      reminderType: id,
    });
    setMale();
  };

  presentPrompt = () => {
    const { tile } = this.props;

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return tile.rules.includes(TileRules.IS_NOT_MALE);
  };

  render() {
    const {
      props: { handler },
      state: { clickedMale },
    } = this;

    return (
      <Root>
        <ReminderButton onClick={() => handler(true)} variation={ButtonVariations.pinkTertiary}>
          Yes
        </ReminderButton>

        <ReminderButton onClick={() => handler(false)} variation={ButtonVariations.pinkTertiary}>
          No
        </ReminderButton>
        {this.presentPrompt() && (
          <NotRelevant onClick={this.handleRelevantClick}>
            {clickedMale ? <CircularProgress /> : <>Not relevant</>}
          </NotRelevant>
        )}
      </Root>
    );
  }
}
